import { createAction } from '@atc/modular-redux';

// Action Creators
import saveRecentSearchActionCreator from './saveRecentSearchActionCreator';
import removeRecentSearchActionCreator from './removeRecentSearchActionCreator';
import hydrateRecentSearchesActionCreator from './hydrateRecentSearchesActionCreator';
import hydrateRecentlySearchedWithListingsActionCreator from './hydrateRecentlySearchedWithListingsActionCreator';
export default (duck, personalization) => ({
  // setters
  setRecentSearches: createAction(duck.types.SET_RECENT_SEARCHES),
  setRecentSearchesInventory: createAction(duck.types.SET_RECENT_SEARCHES_INVENTORY),
  // recentSearch
  hydrateRecentSearches: hydrateRecentSearchesActionCreator(duck, personalization),
  hydrateRecentlySearchedWithListings: hydrateRecentlySearchedWithListingsActionCreator(duck, personalization),
  saveRecentSearch: saveRecentSearchActionCreator(duck, personalization),
  removeRecentSearch: removeRecentSearchActionCreator(duck, personalization),
  editRecentSearch: data => async dispatch => {
    // attempt to edit inventory search. If no index is provided, the latest search will be altered.
    const {
      items
    } = await personalization.editInventorySearch(data);
    dispatch(duck.creators.setRecentSearches(items));
  }
});